import fugroLogo from '../../images/corporate-nav/fugro-logo.png';
import desjardinLogo from '../../images/corporate-nav/desjardin-logo.png';
import wpoLogo from '../../images/corporate-nav/wpo-logo.jpg';
import inkblotLogo from '../../images/custom/logos/inkblot-logo-mlf.png';
import darkInkblotLogo from '../../images/custom/logos/dark-inkblot-logo.png';
import beaconLogo from '../../images/corporate-nav/beacon-logo.jpg';
import lifespeakLogo from '../../images/corporate-nav/lifespeak-logo.png';
import morneauLogo from '../../images/custom/logos/morneau-logo.png';
import selfhelpworksLogo from '../../images/corporate-nav/selfhelpworks-logo.png';
import sunlifeLogo from '../../images/corporate-nav/sunlife-logo.png';
import bewellLogo from '../../images/corporate-nav/bewell-logo.png';
import yrLogo from '../../images/corporate-nav/yr-logo.jpg';
import lifeworksENLogo from '../../images/corporate-nav/lifeworks-logo-en.png';
import homewoodLogo from '../../images/corporate-nav/homewood-logo.jpeg';
import manulifeLogo from '../../images/corporate-nav/manulife-logo.png';
import abcismLogo from '../../images/corporate-nav/abcism-logo.gif';
import associatedambulanceLogo from '../../images/corporate-nav/aa-logo.jpeg';
import sanofiLogo from '../../images/corporate-nav/sanofi-logo.jpeg';
import clarkBuildersCorporate from '../../images/corporate-nav/clark-builders-corporate-logo.jpg';
import cbciLifeworksLogo from '../../images/corporate-nav/cbci-lifeworks-logo.png';
import clarkBuildersLogo from '../../images/corporate-nav/clark-builders-logo.jpg';
import bimboCanadaLogo from '../../images/corporate-nav/bimbo-canada-logo.png';
import frontierLogo from '../../images/corporate-nav/frontier-logo.png';
import humanaCareEnLogo from '../../images/people-connect-total-health/humana-logo-en.png';
import humanaCareFrLogo from '../../images/people-connect-total-health/humana-logo-fr.jpeg';
import peopleConnectLogo from '../../images/people-connect-total-health/people-logo-two.png';
import peopleConnectFrLogo from '../../images/people-connect-total-health/people-logo-two-fr.png';
import mapleLogo from '../../images/people-connect-total-health/maple.png';
import headspaceLogo from '../../images/people-connect-total-health/headspace-logo.svg';
import pocketPillsEnLogo from '../../images/people-connect-total-health/pocket-pills-en.png';
import pocketPillsFrLogo from '../../images/people-connect-total-health/pocket-pills-fr.png';
import aigLogo from '../../images/corporate-nav/aig-logo.png';
import bgbaLogo from '../../images/corporate-nav/bilsland-griffith-benefit-administrators-logo.jpg';
import cooperatorsLogo from '../../images/corporate-nav/co-operators-logo.png';
import gscLogo from '../../images/corporate-nav/gsc-logo.jpg';
import cmawLogo from '../../images/corporate-nav/cmaw-logo.jpg';
import tranquilityLogo from '../../images/corporate-nav/tranquility-logo.png';
import newTranquilityLogo from '../../images/custom/logos/new-tranquility-logo.png';
import tranquilityFrLogo from '../../images/corporate-nav/tranquility-fr-logo.png';
import cbncLogo from '../../images/corporate-nav/canadian-bank-note-company-logo.png';
import cineplexLogo from '../../images/custom/logos/cineplexenglish-logo.png';
import cineplexFrLogo from '../../images/custom/logos/cineplexfrench-logo.png';
import haleoLogo from '../../images/corporate-nav/haleo-logo-fr.jpg';
import FppmLogo from '../../images/corporate-nav/fppm-logo-fr.jpg';
import LululemonLogo from '../../images/custom/logos/lululemon-logo.png';
import LululemonLogoTwo from '../../images/custom/logos/lululemon-chip-logo.png';
import inConfidenceLogo from '../../images/custom/logos/inconfidence-en-logo.png';
import inConfidenceFrLogo from '../../images/custom/logos/inconfidence-fr-logo.png';
import InkblotWordmarkLogo from '../../images/custom/logos/inkblot-logo-wordmark.png';
import MedavieProvider1 from '../../images/custom/logos/meda-provider1.png';
import MedavieProvider2 from '../../images/custom/logos/medavie-provider-2.png';
import MedavieProvider3 from '../../images/custom/logos/meda-provider3.png';
import MedavieProvider4 from '../../images/custom/logos/meda-provider4.png';
import MedavieProvider5 from '../../images/custom/logos/meda-provider5.png';
import MedavieProvider6 from '../../images/custom/logos/meda-provider6.png';
import MedavieProvider7 from '../../images/custom/logos/meda-provider7.png';
import MedavieProvider8 from '../../images/custom/logos/meda-provider8.png';
import MedavieProvider9 from '../../images/custom/logos/meda-provider9.png';

const CommonLogoStyle = {
  maxWidth: '155px',
  minWidth: '100px',
  width: '12%',
};
const corps = [
  {
    marketingURL: 'SanofiMentalHealth',
    path: 'SanofiMentalHealth',
    french: true,
    logo: sanofiLogo,
    title: 'Your mental health resources',
    frTitle: 'Vos ressources en santé mentale',
    subTitle: 'Learn more about your mental health benefits available to you.',
    frSubTitle:
      'Apprenez-en plus sur la couverture de vos avantages sociaux pour soins paramédicaux en santé mentale.',
    providers: [
      {
        logo: inkblotLogo,
        path: 'inkblot',
        ...CommonLogoStyle,
      },
      {
        ...CommonLogoStyle,
        logo: bewellLogo,
        maxWidth: '175px',
        minWidth: '150px',
        width: '25%',
        path: 'ComPsych',
      },
      {
        logo: sunlifeLogo,
        path: 'sunlife',
        ...CommonLogoStyle,
      },
    ],
    provider_sections: [
      {
        logo: inkblotLogo,
        path: 'inkblot',
        type: 'Virtual Therapy',
        frType: 'Thérapie virtuelle',
        name: 'Inkblot Therapy',
        frName: 'Thérapie Inkblot',
        primaryDescription:
          "Inkblot Therapy is Canada's top provider of online video-based one-on-one or couples counselling. Care is provided by highly experienced professionals across Canada. Inkblot highly values long-term relationships with care providers. Your initial individual consultation is complimentary. Subsequent sessions are reimbursable through your paramedical health coverage.<br>",
        frPrimaryDescription:
          'Thérapie Inkblot est le premier fournisseur de thérapie individuelle et de couple en counseling par vidéo au Canada. Les soins sont offerts par des professionnels hautement expérimentés de partout au Canada. Inkblot accorde une grande importance aux relations à long terme avec les prestataires de soins. Votre consultation initiale est gratuite. Les séances suivantes sont remboursables par vos avantages sociaux pour soins paramédicaux.<br>',
        secondaryDescription:
          'Most suitable for those seeking online counselling and a longer-term relationship with their counsellor.',
        frSecondaryDescription:
          'Mieux adapté à ceux qui désirent suivre une thérapie en ligne et développer une relation à long terme avec leur conseiller.e.',
        buttonLabel: 'Launch Inkblot',
        frButtonLabel: 'Lancer Inkblot',
        buttonUrl: 'https://inkblottherapy.com/sanofi',
      },
      {
        logo: bewellLogo,
        path: 'ComPsych',
        type: 'Paramedicals',
        frType: 'Soins paramédicaux',
        name: 'ComPsych',
        frName: 'ComPsych',
        primaryDescription:
          'Offers confidential support for all employees and their household dependents with six free counseling sessions (per person, per issue, per year).  Be Well GuidanceResources has a free hotline available 24/7 that you can contact to ask for advice and support on a wide range of topics, from psychological support to financial and legal guidance.',
        frPrimaryDescription: `Offre un soutien confidentiel à tous les employés et aux personnes à leur charge dans leur foyer, avec six séances de conseil gratuites (par personne, par problématique, par an). Be Well GuidanceResources dispose d'une ligne d'assistance gratuite disponible 24 heures sur 24 et 7 jours sur 7 que vous pouvez contacter pour demander des conseils et un soutien sur un large éventail de sujets, du soutien psychologique à l'orientation financière et juridique.`,
        secondaryDescription: 'Call toll free 1-844-300-2925',
        frSecondaryDescription: 'Numéro sans frais: 1-844-300-2925',
        buttonLabel: 'Launch ComPsych',
        frButtonLabel: 'Lancer ComPsych',
        buttonUrl: 'http://www.bewell.guidanceresources.com/',
      },
      {
        logo: sunlifeLogo,
        path: 'sunlife',
        type: 'Paramedicals',
        frType: 'Soins paramédicaux',
        name: 'Sun Life Financial',
        frName: 'Financière Sun Life',
        primaryDescription:
          'Counselling services by a registered mental health service provider are covered for up to $2,000 per calendar year per covered individual. These providers include clinical counsellors, registered psychologist, registered psychotherapist, and social workers (masters level). <br><br>To view your coverage, visit the Benefits Centre or contact Benefits Centre at 1-855-928-5617 from Monday to Friday 8 am – 8 pm (ET)',
        frPrimaryDescription:
          'Les services de consultation fournis par un prestataire de services en santé mentale agréé sont couverts jusqu&apos;à 2 000 $ par année et par personne assurée. Ces prestataires comprennent les conseillers cliniques, les psychologues agréés, les psychothérapeutes agréés et les travailleurs sociaux (niveau maîtrise). <br><br>Pour consulter votre couverture, visitez le Centre d&apos;avantages sociaux ou contactez le Centre d&apos;avantages sociaux au 1-855-928-5617 du lundi au vendredi de 8 h à 20 h (ET).',
        secondaryDescription: 'Call toll free 1-866-896-6976 ',
        frSecondaryDescription: 'Ligne sans frais 1-866-896-6976',
        buttonLabel: 'Launch Sun Life',
        frButtonLabel: 'Lancer Sun Life',
        buttonUrl: 'https://www.sunnet.sunlife.com/signin/mysunlife/home.wca',
      },
    ],
  },
  {
    marketingURL: 'fugro_nav',
    path: 'fugro_nav',
    logo: fugroLogo,
    title: 'Fugro Benefits',
    subTitle: 'Learn more about your comprehensive benefits package.',
    providers: [
      {
        logo: desjardinLogo,
        maxWidth: '328px',
        width: '21%',
        path: 'desjardin',
      },
      {
        logo: wpoLogo,
        maxWidth: '315px',
        width: '21%',
        path: 'wpo',
      },
      {
        logo: inkblotLogo,
        maxWidth: '315px',
        width: '21%',
        path: 'inkblot',
      },
    ],
    provider_sections: [
      {
        logo: desjardinLogo,
        path: 'desjardin',
        type: 'Health & Medical',
        name: 'Desjardins',
        primaryDescription:
          'Desjardins provides Fugro Canada employees with Health, Dental and Paramedical benefits through its group insurance offerings. This benefit also includes a generous combined maximum of $1000 per year for services with a Psychologist, Psychotherapist and Social Worker.',
        buttonLabel: 'Launch Desjardins',
        buttonUrl:
          'https://www.desjardinslifeinsurance.com/en/group-insurance-plan-members#',
      },
      {
        logo: wpoLogo,
        path: 'wpo',
        type: 'Employee Assistance Program',
        name: 'WPO (Workplace Options)',
        primaryDescription:
          'Fugro’s Global Employee Assistance Program (EAP) through Workplace Options is a confidential counselling and referral program available to eligible employees and their families.<br><br>Accessible online by visiting <a href="http://global.resourcesforyourlife.com/" target="_blank">global.resourcesforyourlife.com</a> with the company code "Fugro" and via their 24-hour line at 1-877-847-4525. The EAP provides a variety of resources.<br><br><b>Most suitable for those seeking short-term counselling or referral.</b>',
        buttonLabel: 'Launch WPO',
        buttonUrl: 'http://global.resourcesforyourlife.com',
      },
      {
        logo: inkblotLogo,
        path: 'inkblot',
        type: 'Virtual Therapy',
        name: 'Inkblot Therapy',
        primaryDescription:
          "Inkblot Therapy is Canada's top provider of online video-based one-on-one or couples counselling. Care is provided by highly experienced professionals across Canada. Inkblot highly values long-term relationships with care providers. Sessions may be reimbursable through your paramedical health coverage.<br><br><b>Most suitable for those seeking online counselling and a longer-term relationship with their counsellor.</b>",
        buttonLabel: 'Launch Inkblot',
        buttonUrl: 'https://inkblottherapy.com/fugrocanada',
      },
    ],
  },
  {
    marketingURL: 'associatedambulancebenefits',
    path: 'associatedambulancebenefits',
    logo: associatedambulanceLogo,
    title: ' Associated Ambulance Benefits',
    subTitle: 'Learn more about your comprehensive benefits package.',
    providers: [
      {
        ...CommonLogoStyle,
        logo: inkblotLogo,
        maxWidth: '328px',
        width: '21%',
        path: 'inblot',
      },
      {
        ...CommonLogoStyle,
        logo: homewoodLogo,
        maxWidth: '315px',
        width: '30%',
        path: 'homewood',
      },
      {
        ...CommonLogoStyle,
        logo: manulifeLogo,
        maxWidth: '315px',
        width: '23%',
        path: 'manulife',
      },
      {
        ...CommonLogoStyle,
        logo: abcismLogo,
        maxWidth: '315px',
        minWidth: '50px',
        width: '10%',
        path: 'peersupport',
      },
    ],
    provider_sections: [
      {
        logo: inkblotLogo,
        path: 'inkblot',
        type: 'Virtual Therapy',
        name: 'Inkblot Therapy',
        primaryDescription:
          'Inkblot Therapy is Canada’s top provider of online video-based one-on-one or couples counselling. Care is provided by highly experienced professionals across Canada through secure video counselling offered at fees significantly lower than the national average and without the barriers or traditional therapy. Your initial individual consultation is complimentary. Subsequent sessions are reimbursable through your Extended Benefit Plan or Taxable Spending Account (TSA).',
        secondaryDescription:
          'Most suitable for those seeking online counselling and a longer-term relationship with their counsellor. Users can seek a counsellor with expertise in a specific area, language or religion to help curate a match. Book your appointment online as soon as the same or next day.',
        buttonLabel: 'Launch Inkblot',
        buttonUrl: 'https://inkblottherapy.com/associatedambulance',
      },
      {
        logo: homewoodLogo,
        path: 'homewood',
        type: 'Employee Family Assistance Program',
        name: 'Homewood Health',
        primaryDescription:
          'Short Term Counselling Services <br> Student Life/Crisis/Family/Legal & Financial/Lifestyle',
        secondaryDescription: 'Life Smart Services',
        buttonLabel: 'Homewood Health; 1 866 644-0326',
        buttonUrl: 'https://homeweb.ca/manulifeefap?lang=en',
      },
      {
        logo: manulifeLogo,
        path: 'manulife',
        type: 'Paramedical Services',
        name: 'Manulife Financial',
        primaryDescription: 'Your company benefit provider',
        buttonLabel: 'Go To: Manulife My Group Benefits',
        buttonUrl: 'https://wwwec7.manulife.com/signin/#benefits',
      },
      {
        logo: abcismLogo,
        path: 'peersupport',
        type: 'Access a peer in your department',
        name: 'AB CISM Peer Activation',
        primaryDescription:
          'Activate one-to-one Peer Support through the ACIPN',
        secondaryDescription:
          'Activate group support for those impacted by a critical incident through ACIPN',
        buttonLabel: 'Go To: AB CISM Peer Activation',
        buttonUrl: 'https://abcism.ca/',
      },
    ],
  },
  {
    marketingURL: 'yr_nav',
    path: 'yr_nav',
    logo: yrLogo,
    title: 'Keeping You Well, YR',
    subTitle: 'Learn more about your mental health benefits.',
    providers: [
      {
        ...CommonLogoStyle,
        logo: inkblotLogo,
        maxWidth: '168px',
        path: 'inkblot',
      },
      {
        logo: morneauLogo,
        path: 'morneau',
        ...CommonLogoStyle,
      },
      {
        logo: lifespeakLogo,
        path: 'lifespeak',
        ...CommonLogoStyle,
      },
      {
        ...CommonLogoStyle,
        logo: sunlifeLogo,
        maxWidth: '168px',
        path: 'sunlife',
      },
      {
        logo: selfhelpworksLogo,
        path: 'selfhelpworks',
        ...CommonLogoStyle,
      },
      {
        logo: beaconLogo,
        path: 'beacon',
        ...CommonLogoStyle,
      },
    ],
    provider_sections: [
      {
        logo: inkblotLogo,
        path: 'inkblot',
        type: 'Virtual Counselling',
        name: 'Inkblot Therapy',
        primaryDescription:
          'Inkblot Therapy is Canada’s top provider of online video-based one-on-one or couples counselling. Care is provided by highly experienced professionals across Canada through secure video counselling offered at fees significantly lower than the national average and without the barriers or traditional therapy. Your initial individual consultation is complimentary. Subsequent sessions are reimbursable through your Extended Benefit Plan or Health Spending Account (HSA).',
        secondaryDescription:
          'Most suitable for those seeking online counselling and a longer-term relationship with their counsellor. Users can seek a counsellor with expertise in a specific area, language or religion to help curate a match. Book your appointment online as soon as the same or next day, with access to crisis support 24/7/365.',
        buttonLabel: 'Launch Inkblot',
        buttonUrl: 'https://inkblottherapy.com/yorkregion',
      },
      {
        logo: morneauLogo,
        path: 'morneau',
        type: 'Employee and Family Assistance Program (EFAP)',
        name: 'Morneau Shepell',
        primaryDescription:
          'Our Employee and Family Assistance Program (EFAP) offers free, confidential and voluntary support 24/7/365 for any work, health or life concern. You and your immediate family members (as defined in your employee benefit plan) can receive support from caring professionals across a variety of platforms including video counseling, group counseling, telephonic or webchat. With real-time online chat (First Chat), you can book a service or speak to a counsellor immediately, no appointment needed. Worklife services include financial, family, and legal support, as well as nutrition, health coaching and naturopathy.',
        secondaryDescription:
          'Download the free MyEAP app to instantly chat with Masters-level clinicians, or call toll-free 24 hours per day, 7 days a week at 1-844-880-9142.',
        buttonLabel: 'Launch EFAP',
        buttonUrl:
          'https://www.workhealthlife.com/Home/WithParam?SYMORG=11148&lang=en-CA',
      },
      {
        logo: lifespeakLogo,
        path: 'lifespeak',
        type: 'Total Well-Being Platform of Expert Advice',
        name: 'LifeSpeak',
        primaryDescription:
          'LifeSpeak is a total well-being online platform to help staff remain present, productive and thrive in life. The platform makes it easy for you and your families to access the support you need to overcome hurdles and accomplish goals, both personal and professional. With over 1000 videos and podcasts on topics ranging from physical health and mental illness to personal and leader development, LifeSpeak features acclaimed authors, medical professionals, and professors offering 24/7/365 expert advice at your fingertips.',
        secondaryDescription:
          'LifeSpeak is available to you at anytime from anywhere. To access the resource, download the free app or visit york.lifespeak.com and create your own account, or sign in with our Corporate ID wellness (case sensitive)',
        buttonLabel: 'Launch LifeSpeak',
        buttonUrl:
          'https://york.lifespeak.com/Account/Login?ReturnUrl=%2fwelcome',
      },
      {
        logo: sunlifeLogo,
        path: 'sunlife',
        type: 'Health Benefits',
        name: 'Sun Life',
        primaryDescription:
          'Mental health paramedical benefits coverage of $1000 per benefit year is available for eligible plan members through the extended health benefit or Health Spending Account (HSA). Be sure to check your benefit booklet for coverage details. NOTE: CUPE members and Non Union employees have coverage for a psychologist and a social worker with a Masters of Social Work (MSW), but do NOT have coverage for a psychotherapist. ONA members have coverage for a psychologist or a social worker (who has their MSW) or a psychotherapist. Additional mental health resources can be found at <a href="https://luminohealth.sunlife.ca" target="_blank">luminohealth.sunlife.ca</a>',
        secondaryDescription:
          'Find the benefit booklet that applies to you, or register an account on the Sun Life website to view your coverage and make claims online.',
        buttonLabel: 'Launch Sun Life',
        buttonUrl: 'https://luminohealth.sunlife.ca',
      },
      {
        logo: selfhelpworksLogo,
        path: 'selfhelpworks',
        type: 'Self-Development Online Training ',
        name: 'SelfHelpWorks ',
        primaryDescription:
          'Based on cognitive behaviour therapy training, seven self-directed courses are available to help you reach your personal health goals. From managing stress or addictions, to eating better or moving more, these online behaviour modification courses run anywhere from 6 to 12 weeks and are designed to help you build healthy habits for life.',
        secondaryDescription:
          'To find the course for you, visit <a href="https://portals.selfhelpworks.com/public/app2/#!/landing" target="_blank">portals.selfhelpworks.com</a> and enter activation code YR-SHW',
        buttonLabel: 'Launch SelfHelpWorks',
        buttonUrl: 'https://portals.selfhelpworks.com/public/app2/#!/landing',
      },
      {
        logo: beaconLogo,
        path: 'beacon',
        type: 'Guided Digital Therapy',
        name: 'Beacon',
        primaryDescription:
          'Available through our Extended Health Benefits, Beacon offers digital therapy guided by an accredited therapist. The 12-week course begins with a personal assessment followed by cognitive behavioural therapy activities customized by your dedicated therapist to help you manage your thoughts and feelings. Most suitable to improve mild to moderate symptoms of depression, anxiety, post-traumatic stress injury (PTSI/PTSD) and insomnia.',
        secondaryDescription:
          "Complete Beacon therapy at your own pace, anytime and anywhere you're comfortable. Most people complete their personalized course in 6 to 10 weeks.<br><br>Ready to get started free of charge? Sign up for a secure account (valid email address required).",
        buttonLabel: 'Launch Beacon',
        buttonUrl: 'https://info.mindbeacon.com/btn542',
      },
      {
        logo: yrLogo,
        path: 'other',
        type: 'Free Community Supports',
        name: 'Additional Supports during COVID19',
        primaryDescription:
          'In response to COVID19, the Government of Canada has secured additional resources to support you:<ul><li>ConnexOntario – call 1-866-531-2600 for addiction, mental health and problem gambling support</li><li>WellCan – download the app for a collection of mental health resources available to everyone in Canada</li><li>Wellness Together Canada - a government resource offering free online tools, apps and connections to trained volunteers and qualified mental health professionals to help Canadians get back on track</li></ul>',
        secondaryDescription:
          'Remember, you are not alone. If you or someone you know is in crisis, call 911 immediately or go to your nearest emergency department for assistance.',
        buttonLabel: 'Launch Your Local Crisis Centre',
        buttonUrl:
          'https://thelifelinecanada.ca/suicide-prevention-crisis-centre-contact-information/crisis-centres/canadian-crisis-centres/',
      },
    ],
  },
  {
    marketingURL: 'clarkbuilderscorporate_nav',
    path: 'clarkbuilderscorporate_nav',
    logo: clarkBuildersCorporate,
    title: 'Clark Builders Corporate Program',
    subTitle:
      'Learn more about your comprehensive benefit program and our mental health offerings. If you have any questions about your benefits, please contact <a href="mailto:hr@cbgoc.com">hr@cbgoc.com</a>',
    providers: [
      {
        logo: inkblotLogo,
        maxWidth: '168px',
        width: '23%',
        path: 'inkblot',
      },
      {
        logo: lifeworksENLogo,
        maxWidth: '168px',
        width: '23%',
        path: 'lifeworks',
      },
      {
        logo: manulifeLogo,
        maxWidth: '190px',
        width: '23%',
        path: 'manulife',
      },
    ],
    provider_sections: [
      {
        logo: inkblotLogo,
        path: 'inkblot',
        type: 'Virtual Therapy',
        name: 'Inkblot',
        primaryDescription:
          'Inkblot Therapy is Canada’s top provider of online video-based one-on-one or couples counselling. Care is provided by highly experienced professionals across Canada through secure video counselling offered at fees significantly lower than the national average and without the barriers or traditional therapy. Your initial individual consultation is complimentary. Subsequent sessions are reimbursable through your Extended Benefit Plan.',
        secondaryDescription:
          'Most suitable for those seeking online counselling and a longer-term relationship with their counsellor. Users can seek a counsellor with expertise in a specific area, language or religion to help curate a match. Book your appointment online as soon as the same or next day.',
        buttonLabel: 'Launch Inkblot',
        buttonUrl: 'https://inkblottherapy.com/clarkbuilderscorporate',
      },
      {
        logo: lifeworksENLogo,
        path: 'lifeworks',
        type: 'Employee Family Assistance Program ',
        name: 'LifeWorks',
        primaryDescription:
          '24/7 Short Term Counselling Services and Wellness Services.',
        secondaryDescription:
          'Access LifeWorks for emergency counselling support, short-term counselling needs, or for additional resources for all areas of wellness including health risk assessments, financial and legal advice,  childcare and parenting services, fitness training, and relationship solutions. Call 1-844-880-9137 for immediate support or visit their website for more information.',
        buttonLabel: 'Access LifeWorks Now',
        buttonUrl: 'https://login.lifeworks.com',
      },
      {
        logo: manulifeLogo,
        path: 'manulife',
        type: 'Paramedical Services',
        name: 'Manulife Financial',
        primaryDescription:
          'Access to Psychology services from an eligible mental health professional.',
        secondaryDescription:
          '100% reimbursement up to up to a specified amount per year for the services of a Psychologist, Master of Social Work, Psychotherapist, Psychoanalyst, Psychiatrist, Marriage & Family Therapist, or Clinical Counsellor.',
        buttonLabel: 'Login to Manulife',
        buttonUrl: 'https://wwwec7.manulife.com/signin/',
      },
    ],
  },
  {
    marketingURL: 'clarkbuildersfield_nav',
    path: 'clarkbuildersfield_nav',
    logo: clarkBuildersLogo,
    title: 'Frontier & CBCI Benefits',
    subTitle:
      'Learn more about your comprehensive benefit program and our mental health offerings. If you have any questions about your benefits, please contact <a href="mailto:hr@cbgoc.com">hr@cbgoc.com</a>.',
    providers: [
      {
        logo: inkblotLogo,
        maxWidth: '168px',
        width: '23%',
        path: 'inkblot',
      },
      {
        logo: frontierLogo,
        maxWidth: '168px',
        width: '23%',
      },
      {
        logo: lifeworksENLogo,
        maxWidth: '168px',
        width: '23%',
      },
      {
        logo: cbciLifeworksLogo,
        maxWidth: '168px',
        width: '23%',
      },
    ],
    provider_sections: [
      {
        logo: inkblotLogo,
        path: 'inkblot',
        type: 'Virtual Therapy',
        name: 'Inkblot',
        primaryDescription:
          'Inkblot Therapy is Canada’s top provider of online video-based one-on-one or couples counselling. Care is provided by highly experienced professionals across Canada through secure video counselling offered at fees significantly lower than the national average and without the barriers or traditional therapy. Your initial individual consultation is complimentary. Subsequent sessions are reimbursable through your Extended Benefit Plan.',
        secondaryDescription:
          'Most suitable for those seeking online counselling and a longer-term relationship with their counsellor. Users can seek a counsellor with expertise in a specific area, language or religion to help curate a match. Book your appointment online as soon as the same or next day.',
        buttonLabel: 'Launch Inkblot',
        buttonUrl: 'https://inkblottherapy.com/clarkbuildersfield',
      },
      {
        logo: lifeworksENLogo,
        secondLogo: frontierLogo,
        path: 'meritLifeWorks',
        type: 'Employee Family Assistance Program',
        name: 'Open Circle',
        primaryDescription:
          '24/7 Short Term Counselling Services and Wellness Services',
        secondaryDescription:
          'Access LifeWorks for emergency counselling support, short-term counselling needs, or for additional resources for all areas of wellness including health risk assessments, financial and legal advice,  childcare and parenting services, fitness training, and relationship solutions. Call 1-844-880-9137 for immediate support or visit their website for more information.<br><br>To access LifeWorks, click \'Access LifeWorks Now\', then select "Sign Up". The site will ask for your Invitation Code and your Unique Code. Your Invitiation Code is "MB1-" then the last nine digits of your member ID # found on your benefits ID card. For example, if you member ID shows 0001234567, then your Invitation Code would be MB1-001234567.  Your Unique Code is your birthday in MM/DD/00 (use zeros for the year). For example, if your birthday is June 8 you would input it as 06/08/00.',
        buttonLabel: 'Access LifeWorks Now',
        buttonUrl: 'https://login.lifeworks.com',
      },
      {
        logo: lifeworksENLogo,
        secondLogo: cbciLifeworksLogo,
        path: 'cbciLifeWorks',
        type: 'Employee Family Assistance Program',
        name: 'CBCI LifeWorks',
        primaryDescription:
          '24/7 Short Term Counselling Services and Wellness Services',
        secondaryDescription:
          "Access LifeWorks for emergency counselling support, short-term counselling needs, or for additional resources for all areas of wellness including health risk assessments, financial and legal advice,  childcare and parenting services, fitness training, and relationship solutions. Call 1-877-207-8833 for immediate support or visit their website for more information. To access LifeWorks click 'Access LifeWorks Now'. To sign in, use the User ID: cibp. The password will be: eap",
        buttonLabel: 'Access LifeWorks Now',
        buttonUrl: 'https://lifeworks.com',
      },
      {
        logo: frontierLogo,
        path: 'meritContractorAssociation',
        type: 'Paramedical Services',
        name: 'Open Circle',
        primaryDescription:
          'Access to Psychology services from an eligible mental health professional.',
        secondaryDescription:
          '100% reimbursement up to a specified amount per year for the services of a Psychologist or Social Worker.',
        buttonLabel: 'Login to Open Circle',
        buttonUrl: 'https://meritnational.com/login/',
      },
      {
        logo: cbciLifeworksLogo,
        path: 'constructionIndustryBenefits',
        type: 'Paramedical Services',
        name: "The Construction Industry's Benefit Plan - CBCI",
        primaryDescription:
          'Access to Psychology services from an eligible mental health professional.',
        secondaryDescription:
          '100% reimbursement up to a specified amount per year for the services of a Psychologist, Social Worker, or Clinical Counsellor.',
        buttonLabel: 'Login to CIBP',
        buttonUrl: 'https://mycibp.ca/',
      },
    ],
  },
  {
    marketingURL: 'ppc_health_bimbo',
    path: 'ppc_health_bimbo',
    logo: bimboCanadaLogo,
    title:
      'Total Health - Helping you take care of your physical and mental health',
    frTitle:
      'Santé globale - Des services pour vous aider à soigner votre santé physique et mentale',
    french: true,
    subTitle:
      'Total Health is a <i><u>confidential</u></i> health care solution, that includes access to doctors, Employee and Family Assistance Program (EFAP), virtual mental health care and an online pharmacy, making it easy for you and your dependent family members to get needed treatment from the comfort and safety of your own home.<br><br>To learn more about Total Health services, please view these videos.<br><a href="https://vimeo.com/762684352">Total Health</a> <a href="https://vimeo.com/762687248">HumanaCare EFAP</a>',
    frSubTitle:
      'Santé globale est une solution de soins de santé <i><u>confidentielle</u></i> qui offre l’accès à des médecins, un programme d’aide aux employés (PAE), des soins de santé mentale virtuels et une pharmacie en ligne, pour que vous et vos personnes à charge puissiez obtenir facilement le traitement dont vous avez besoin dans le confort et la sécurité de votre foyer.<br><br>Pour en apprendre davantage sur les services de la Santé Globale, veuillez visionner ces vidéos. <br><a href="https://vimeo.com/762682691">Santé Globale</a> <a href="https://vimeo.com/762702930?utm_source=email&utm_medium=vimeo-cliptranscode-201504&utm_campaign=28749">HumanaCare PAEF</a>',
    providers: [
      {
        logo: humanaCareEnLogo,
        frLogo: humanaCareFrLogo,
        maxWidth: '238px',
        width: '23%',
        path: 'humanacare',
      },
      {
        logo: mapleLogo,
        maxWidth: '168px',
        width: '23%',
        path: 'maple',
      },
      {
        logo: headspaceLogo,
        maxWidth: '168px',
        width: '23%',
        path: 'headspace',
      },
      {
        logo: peopleConnectLogo,
        frLogo: peopleConnectFrLogo,
        maxWidth: '211px',
        width: '23%',
        path: 'peopleconnect',
      },
      {
        logo: pocketPillsEnLogo,
        frLogo: pocketPillsFrLogo,
        maxWidth: '248px',
        width: '23%',
        path: 'pocketpills',
      },
    ],
    provider_sections: [
      {
        logo: humanaCareEnLogo,
        frLogo: humanaCareFrLogo,
        path: 'humanacare',
        type: 'Employee and Family Assistance Program (EFAP)',
        frType: 'Programme d’aide aux employés (PAE)',
        name: 'HumanaCare – help with personal or work-related issues',
        frName:
          'HumanaCare – Aide à la résolution des problèmes personnels et professionnels',
        primaryDescription:
          'Use for: Free short term counselling for managing everyday challenges',
        frPrimaryDescription:
          'Utilité : Obtenir des services de consultation de courte durée gratuits pour composer avec les difficultés de la vie courante',
        secondaryDescription:
          'EFAP provides free 24/7/365 services to support associates and their dependent family members’ day to day wellbeing. <br><br>Free Services include: <br><br><ul><li>Short term counselling (single, couples, face to face, video, telephonic)</li><li>Legal consultation (with a lawyer)</li><li>Financial consultation (with a financial expert)</li><li>Nutrition consultation (with a registered dietician)</li><li>Overall Wellness/Health consultation (sleep, stress, etc.)</li><li>Daily living consultations (pet care, eldercare, childcare, locating community services)</li><li>Online resources – articles, courses, webinars</li></ul><br><b>How to access HumanaCare:</b><ul><li><b>Telephone</b> - Call toll free 24 Hours: 1-833-613-0968</li><li><b>Website</b> - Access our website at <a href="https://www.humanacare.com/humanalife">www.humanacare.com/humanalife</a></li></ul><ul>Company code: BimboCanada </ul><ul>Password: BimboCanada</ul>OR <ul><li><b>App</b> - Download the HumanaCare App</li></ul><ul>Access the website at <a href="http://www.humanacare.com/bimbo"> humanacare.com/bimbo </a> </ul><ul>You will be prompted to sign up with your email to receive an activation link to create a personal profile.</ul><br>Learn about EAP services: <a href="https://api.inkblotpractice.com/production/HumanaCareEAPPosterBimboCanadaEN.pdf">Poster</a>',
        frSecondaryDescription:
          'Dans le cadre du PAE, les collaborateurs et leurs personnes à charge peuvent obtenir en tout temps des services de soutien gratuits pour faire face aux difficultés de la vie courante. <br><br>Les services gratuits suivants sont offerts: <br><br><ul><li>Services de consultation de courte durée (personnes seules, couples, consultations en personne, par vidéoconférence ou par téléphone)</li><li>Conseils juridiques (offerts par un avocat)</li><li>Conseils financiers (offerts par un expert financier)</li><li>Conseils en nutrition (offerts par un diététiste agréé)</li><li>Conseils en mieux-être et santé (sommeil, stress, etc.)</li><li>Conseils sur les besoins courants (soins des animaux de compagnie, soins des aînés, garde des enfants, recherche de services communautaires)</li><li>Ressources en ligne (articles, cours, webinaires)</li></ul><br><b>Coordonnées de HumanaCare:</b><ul><li><b>Téléphone</b> - Appels sans frais en tout temps: 1 833 613-0968</li><li><b>Site Web </b> - Allez sur notre site Web à <a href="https://humanacare.com/portail-des-membres-employes/">www.humanacare.com/humanalife</a></li></ul><ul>Code d’entreprise: BimboCanada </ul><ul>Mot de passe: BimboCanada</ul>OU <ul><li><b>Application</b> - Téléchargez l’application HumanaCare</li></ul><ul>Allez sur le site <a href="https://humanacare.com/bimbo/?lang=fr"> humanacare.com/bimbo </a> </ul><ul>Vous serez invité à saisir votre adresse de courriel pour vous inscrire et vous recevrez un lien pour activer votre compte et créer votre profil.</ul><br>Renseignez-vous sur les services offerts dans le cadre du PAE: <a href="https://api.inkblotpractice.com/production/HumanaCareEAPPosterBimboCanadaFR.pdf">Affiche</a>',
        buttonLabel: 'Access Humanacare',
        frButtonLabel: 'Accéder Humanacare',
        buttonUrl: 'https://humanacare.com/humanalife/',
        frButtonUrl: 'https://humanacare.com/portail-des-membres-employes/',
      },
      {
        logo: mapleLogo,
        path: 'maple',
        type: 'Virtual Medical Care',
        frType: 'Soins médicaux virtuels',
        name: 'Maple – confidential virtual medical care',
        frName: 'Maple – Soins médicaux virtuels confidentiels',
        primaryDescription:
          'Use for: Free online medical care for minor issues instead of going in to see your family doctor',
        frPrimaryDescription:
          'Utilité : Obtenir des soins médicaux en ligne pour régler des problèmes bénins au lieu d’aller voir votre médecin de famille',
        secondaryDescription:
          "Maple is a virtual health app providing you and your family members with quick and easy access to general physicians (including emergency room and family physicians). Maple offers an upfront online assessment, followed by virtual appointments with doctors, on-demand, 24/7/365. <br> <br> You have access to 2 FREE consults with a general practitioner per family member per calendar year. <br><br><b>How to Access Maple: </b> <br> &ensp; 1. Click the Access Maple button below to get started &emsp;&ensp; <div style='padding-left:35px;'>* You will require your Oracle ID to register for this program. If you don't know your Oracle ID, please ask your supervisor/manager or email <a href='mailto:bimbocanada@peoplecorporation.com'>bimbocanada@peoplecorporation.com</a>.</div> <br> &ensp; 2. To contact a Doctor, download the Maple app from the <span style='padding-left: 35px'> <a href='https://apps.apple.com/ca/app/maple-24-7-online-doctors/id1294926209'> App Store </a> or <a href='https://play.google.com/store/apps/details?id=com.maplenativeuser&referrer=utm_source%3Dgoogle%26utm_medium%3Dorganic%26utm_term%3D(none)%26utm_content%3D(none)%26utm_campaign%3D(none)'> Google Play </a> </span> <br><br>&emsp;&nbsp;&nbsp; <a href='https://api.inkblotpractice.com/production/MapleOverviewBimboCanadaEN.pdf'> Learn how to get set up </a> <br><br> Questions? Contact: <a href='mailto:support@getmaple.ca'> support@getmaple.ca </a>",
        frSecondaryDescription:
          "Maple est une application de soins de santé virtuels grâce à laquelle vous et les membres de votre famille pouvez accéder de manière rapide et simple à des médecins généralistes (qui pratiquent la médecine d’urgence ou la médecine familiale). Maple offre une évaluation initiale en ligne, suivie de consultations virtuelles avec des médecins sur demande, en tout temps. <br> <br> Vous avez droit à deux consultations GRATUITES avec un médecin généraliste par membre de la famille et par année civile. <br><br><b>Pour accéder à Maple: </b> <br> &ensp; 1. Cliquez sur le bouton Accès Maple ci-dessous pour débuter. &emsp;&ensp; <div style='padding-left:35px;'>*Vous devrez saisir votre numéro de collaborateur Oracle pour vous inscrire à ce programme. Si vous ne connaissez pas votre numéro de collaborateur Oracle, demandez-le à votre superviseur ou votre gestionnaire ou envoyez un courriel à <a href='mailto:bimbocanada@peoplecorporation.com'>bimbocanada@peoplecorporation.com</a>.</div> <br> &ensp; 2. Pour consulter un médecin, téléchargez l’application <span style='padding-left: 35px'> Maple à partir de l’ <a href='https://apps.apple.com/ca/app/maple-24-7-online-doctors/id1294926209'> App Store </a> ou de <a href='https://play.google.com/store/apps/details?id=com.maplenativeuser&referrer=utm_source%3Dgoogle%26utm_medium%3Dorganic%26utm_term%3D(none)%26utm_content%3D(none)%26utm_campaign%3D(none)'> Google Play </a> </span> <br><br>&emsp;&nbsp;&nbsp; <a href='https://api.inkblotpractice.com/production/MapleOverviewBimboCanadaFR.pdf'> Apprenez comment créer votre compte </a> <br><br> Des questions? Écrivez à <a href='mailto:support@getmaple.ca'> support@getmaple.ca </a>",
        buttonLabel: 'Access Maple',
        frButtonLabel: 'Accéder Maple',
        buttonUrl: 'https://www.getmaple.ca/bimbocanada',
        frButtonUrl: 'https://app.getmaple.ca/register?locale=fr',
      },
      {
        logo: headspaceLogo,
        path: 'headspace',
        type: 'MENTAL HEALTH – Mindfulness and meditation',
        frType: 'SANTÉ MENTALE – Pleine conscience et méditation',
        name: 'Headspace App – personal wellness app',
        frName: 'Application de mieux-être personnel Headspace',
        primaryDescription:
          'Use for: relieving stress, improving sleep and mental health through meditation and mindfulness',
        frPrimaryDescription:
          'Headspace est une application qui aide les gens à gérer le stress et à améliorer leur bien-être mental général. Headspace vous permet de bénéficier des services',
        secondaryDescription:
          'Headspace is a meditation app that helps people manage stress and improve their overall mental well-being. With Headspace you’ll have <u><b>free</b></u> access to: <br><br><div style="padding-left: 35px;display:flex;"> ✓<div style="padding-left:10px">Guided meditations, courses, and mindfulness exercises</div></div><div style="padding-left: 35px;display:flex;"> ✓<div style="padding-left:10px">Sleepcasts, music, and nature sounds</div></div><div style="padding-left: 35px;display:flex;"> ✓<div style="padding-left:10px">Quick workout videos including yoga, mindful walks, and guided cardio</div></div><br><br><b>How to Access Headspace: </b><br><br><ul style="padding-left:35px"><li><b>If you have a Maple account already </b>, please be sure to use the same email as your Maple account when creating your Headspace account.</li><li><b>If you don’t have a Maple account already</b>, please have your Oracle associate ID handy. You will receive an invitation from Headspace <i><u>24 hours after registering</u></i> for a Maple account.</li></ul>',
        frSecondaryDescription:
          'Headspace est une application qui aide les gens à gérer le stress et à améliorer leur bien-être mental général. Headspace vous permet de bénéficier des services <u><b>gratuits</b></u> suivants: <br><br><div style="padding-left: 35px;display:flex;"> ✓<div style="padding-left:10px">Séances de méditation guidées, cours et exercices de pleine conscience</div></div><div style="padding-left: 35px;display:flex;"> ✓<div style="padding-left:10px">Balados propices au sommeil, musique et bruits de la nature</div></div><div style="padding-left: 35px;display:flex;"> ✓<div style="padding-left:10px">Courtes vidéos d’entraînement – yoga, marche en pleine conscience et entraînement cardiovasculaire</div></div><br><br><b>Pour accéder à Headspace: </b><br><br><ul style="padding-left:35px"><li><b>Si vous avez déjà un compte Maple</b>, assurez-vous d’utiliser le même courriel que Maple lors de votre inscription à Headspace.</li><li><b>Si vous n’avez pas de compte Maple</b>, veuillez avoir à portée de main votre identifiant Oracle d’associé. Vous recevrez une invitation de Headspace <i><u>24 heures après</u></i> votre inscription à Maple.</li></ul>',
        buttonLabel: 'Access Headspace',
        frButtonLabel: 'Accéder Headspace',
        buttonUrl: 'https://work.headspace.com/mapleb2b/member-enroll',
        frButtonUrl: 'https://headspace.com/getmapleforbusiness',
      },
      {
        logo: peopleConnectLogo,
        frLogo: peopleConnectFrLogo,
        path: 'peopleconnect',
        type: 'MENTAL HEALTH – Talk Therapy',
        frType: 'SANTÉ MENTALE – Psychothérapie',
        name: 'People Connect – confidential virtual counselling',
        frName:
          'People vous connecte – Consultations virtuelles confidentielles',
        primaryDescription:
          'Use for: medium to long term support for personal mental health challenges and symptoms',
        frPrimaryDescription:
          'Utilité : Obtenir un soutien de moyenne ou de longue durée pour régler des symptômes et des problèmes personnels de santé mentale',
        secondaryDescription:
          'People Connect uses the coverage provided under your group benefits plan making it easy to get professional and affordable therapy. <br><br>This service provides you and your family members with: <br><br><ul><li>Access to immediate care through video counselling</li><li>A self-assessment tool to help you better understand what you’re feeling</li></ul> <br>There is <i>no charge</i> for the first 30-minute appointment. Pay for your sessions up front, then submit a claim  through paramedical coverage or HCSA if you have coverage under the company benefit plan.  Check your benefit plan or call Sun Life at 1 800 361 6212 if you need confirmation of coverage amount.<br><br> How to access People Connect: <br> <a href="https://pcpeopleconnect.com/"> Click the Access People Connect button below to get started </a> <br>*When registering, type Bimbo in the company field and then select Bimbo Canada from the drop down <br><br><a href="https://vimeo.com/738734767" target="_blank"> Learn more about People Connect</a><br><br> <b><u>Questions? Contact: </b></u><a href="mailto:support@pcpeopleconnect.com"> support@pcpeopleconnect.com </a>',
        frSecondaryDescription:
          'Les services fournis dans le cadre de People vous connecte sont couverts en tant que services de praticiens paramédicaux au titre de votre régime d’assurance collective, ce qui permet d’avoir facilement accès à une thérapie professionnelle et abordable. <br><br>Vous et les membres de votre famille bénéficiez des services suivants: <br><br><ul><li>Accès immédiat à des soins sous forme de vidéothérapie</li><li>Outil d’autoévaluation qui vous aidera à mieux comprendre les sentiments qui vous habitent</li></ul> <br>Le programme comprend une séance initiale de 30 minutes <i>gratuite</i>. Ensuite, vous payez les frais de consultation et vous obtenez un remboursement au titre de la couverture des praticiens paramédicaux ou de votre CSS si vous participez au régime d’avantages sociaux de l’entreprise.  Consultez votre livret explicatif ou appelez la Sun Life au 1 800 361-6212 pour connaître le montant de votre couverture.<br><br> Pour accéder à People vous connecte: <br><a href="https://peoplevousconnecte.com/"> Cliquez sur le bouton Accès People Connect ci-dessous pour débuter </a><br>*Pour vous inscrire, saisissez Bimbo dans le champ Entreprise, puis sélectionnez Bimbo Canada dans la liste déroulante. <br><br><a href="https://vimeo.com/738967866"> <b><u>Renseignements complémentaires sur le programme People vous connecte</a><br><br> Des questions? Écrivez à:</u></b> <a href="mailto:support@pcpeopleconnect.com"> support@pcpeopleconnect.com </a>',
        buttonLabel: 'Access People Connect',
        frButtonLabel: 'Accéder People Connect',
        buttonUrl: 'https://pcpeopleconnect.com/',
        frButtonUrl: 'https://peoplevousconnecte.com/',
      },
      {
        logo: pocketPillsEnLogo,
        frLogo: pocketPillsFrLogo,
        path: 'pocketpills',
        type: 'PHARMACY',
        frType: 'SERVICES PHARMACEUTIQUES',
        name: 'PocketPills – Virtual pharmacy',
        frName: 'PocketPills – Pharmacie virtuelle',
        primaryDescription:
          'Use for: ordering or refilling prescriptions and pharmacist support',
        frPrimaryDescription:
          'Utilité : Commander des médicaments, renouveler des ordonnances ou obtenir les conseils d’un pharmacien.',
        secondaryDescription:
          'An online Pharmacy service to help you and your family members get your medications without leaving your home. Available pharmacist support to learn about your prescription and diagnosis.<br><br><ul style="padding-left:35px"><li>24/7/365 easy access to pharmacists via live chat, SMS, email, and phone</li><li>PocketPacks – organizes doses with easy tear packaging</li><li><u><i>Free</i></u> delivery </ul> <br><b>How to access:</b> <br> To register and transfer existing prescriptions from another pharmacy: <ul style="padding-left:35px"><li>Please have a picture of the front and back of your primary insurance card, your health card and your existing pharmacy information ready.</li></ul><br> If you do not wish to transfer prescriptions right away, you do not need this information.  Please leave “Referral Code” blank. <br><br> Click the Access PocketPills button below to get started <br><br> Questions? Contact: 1-833-HELLORX<br><br> <a href = "https://vimeo.com/380532695">Learn more about PocketPills</a>',
        frSecondaryDescription:
          'Service de pharmacie en ligne pour vous et les membres de votre famille qui vous permet d’obtenir vos médicaments sans sortir de chez vous. Conseils d’un pharmacien sur les médicaments qui vous ont été prescrits et votre diagnostic.<br><br><ul style="padding-left:35px"><li>Accès facile et en tout temps à des pharmaciens par clavardage, texto, courriel ou téléphone.</li><li>Organisation de vos médicaments par dose dans des emballages PocketPacks faciles à ouvrir.</li><li>Livraison <u><i>gratuite</i></u></ul> <br><b>Pour accéder à PocketPills:</b> <br> Pour vous inscrire et transférer vos ordonnances existantes d’une autre pharmacie: <ul style="padding-left:35px"><li>Ayez à portée de main une photo de votre carte d’assurance médicaments principale, côtés recto et verso, et les coordonnées de votre pharmacie actuelle.</li></ul><br>Si vous ne souhaitez pas transférer tout de suite vos ordonnances, vous n’aurez pas besoin de ces renseignements.  Veuillez laisser le champ « Referral Code » vide. <br><br> Cliquez sur le bouton Accès PocketPills ci-dessous pour débuter<br><br> Des questions? Appelez au 1 833 HELLORX<br><br> <a href = "https://player.vimeo.com/video/480019502">Renseignements complémentaires sur PocketPills</a>',
        buttonLabel: 'Access PocketPills',
        frButtonLabel: 'Accéder PocketPills',
        buttonUrl: 'https://www.pocketpills.com/bimbo-canada',
        frButtonUrl: 'https://www.pocketpills.com/bimbo-canada',
      },
    ],
  },
  {
    marketingURL: 'cmaw_nav',
    path: 'cmaw_nav',
    logo: cmawLogo,
    title: 'CMAW Benefit Plan',
    subTitle: 'Learn more about your comprehensive benefits package.',
    providers: [
      {
        logo: gscLogo,
        maxWidth: '10%',
        path: 'gsc',
      },

      {
        logo: cooperatorsLogo,
        maxWidth: '15%',
        path: 'cooperator',
      },
      {
        logo: bgbaLogo,
        maxWidth: '15%',
        path: 'bgba',
      },
      {
        logo: inkblotLogo,
        maxWidth: '10%',
        path: 'inkblot',
      },
      {
        logo: aigLogo,
        maxWidth: '8%',
        path: 'aig',
      },
    ],
    provider_sections: [
      {
        logo: gscLogo,
        path: 'gsc',
        type: 'Extended Health Care, Vision Care, and Dental',
        name: 'Green Shield Canada',
        primaryDescription:
          'Green Shield Canada is a leader in the health benefits industry, with an extensive network of health care professionals who invoice them directly, which means no claim forms and no mailing costs. With online services, you can sign up for Direct Deposit so claim payments can be deposited directly into your bank account.',
        buttonLabel: 'Launch Green Shield Canada',
        buttonUrl: 'https://gsceverywhere.ca/login',
      },
      {
        logo: cooperatorsLogo,
        path: 'cooperator',
        type: 'Life Insurance, Short Term Disability, and Long Term Disability',
        name: 'Co-operators',
        primaryDescription:
          'The Co-operators Group Limited is a Canadian-owned co-operative with over 70 years of history. Their advisors are knowledgeable and will answer any questions you may have and make things as simple and easy as possible throughout the claims process.',
        buttonLabel: 'Launch Co-operators',
        buttonUrl: 'https://www.cooperators.ca/en.aspx',
      },
      {
        logo: bgbaLogo,
        path: 'bgba',
        type: 'Plan Administrator, Travel Assistance and Bereavement Leave',
        name: 'Bilsland Griffith Benefit Administrators',
        primaryDescription:
          'Bilsland Griffith Benefit Administrators ("BG") is a locally based pension and benefits administration firm providing services to negotiated cost and multi employer benefit plans and trusts. BG is proud to offer top-tier services provided by the very best administration professionals working in the industry today.',
        buttonLabel: 'Launch BG Benefits Admin',
        buttonUrl: 'https://www.cmaw.ca/pension-and-benefits',
      },
      {
        logo: inkblotLogo,
        path: 'inkblot',
        type: 'Virtual Therapy',
        name: 'Inkblot Therapy',
        primaryDescription:
          "Inkblot Therapy is Canada's top provider of online video-based one-on-one or couples counselling. Care is provided by highly experienced professionals across Canada. Inkblot highly values long-term relationships with care providers. Sessions may be reimbursable through your paramedical health coverage.",
        buttonLabel: 'Launch Inkblot',
        buttonUrl: 'https://www.cmawefap.ca',
      },
      {
        logo: tranquilityLogo,
        path: 'tranquility',
        type: 'Coach-Assisted iCBT',
        name: 'Tranquility by Inkblot',
        primaryDescription:
          'Tranquility by Inkblot is an innovative program offering internet cognitive behavioural therapy (ICBT) to help you reduce mild to moderate symptoms of anxiety and depression right from the comfort of home. Learn positive coping strategies and reduce life-disrupting mental health symptoms through our interactive learning modules, tools and one-to-one coaching sessions. Work through the modules at your own pace and your own time.',
        buttonLabel: 'Register for Tranquility by Inkblot',
        buttonUrl: 'https://cmaw.tranquility.app/onboarding',
      },
      {
        logo: aigLogo,
        path: 'aig',
        type: 'Accidental Death and Dismemberment',
        name: 'AIG',
        primaryDescription:
          "AIG's extensive worldwide property-casualty network provide solutions to the full spectrum of individuals, families, and other sponsoring organizations around the world. AD&D benefits cover accidents on or off the job, at home, while travelling by automobile, train, or as a passenger on a commercial airline.",
        buttonLabel: 'Launch AIG',
        buttonUrl: 'https://www.aig.ca/home',
      },
    ],
  },
  {
    marketingURL: 'cbnco',
    path: 'cbnco',
    french: true,
    logo: cbncLogo,
    title: 'Canadian Bank Note Company, Limited Benefits',
    frTitle: 'Canadian Bank Note Company, Limited Benefits',
    subTitle:
      'Learn more about your mental health benefits provided by Inkblot Therapy',
    frSubTitle:
      'Renseignez-vous sur les prestations de santé mentale fournies par Thérapie Inkblot',
    providers: [
      {
        logo: inkblotLogo,
        path: 'inkblot',
        ...CommonLogoStyle,
      },
      {
        logo: tranquilityLogo,
        path: 'tranquility',
        ...CommonLogoStyle,
      },
    ],
    provider_sections: [
      {
        logo: inkblotLogo,
        path: 'inkblot',
        type: 'Employee Assitance Provider (EAP)',
        frType: ' Programme d’aide aux employés (PAE)',
        name: 'Inkblot Therapy',
        frName: 'Thérapie Inkblot',
        primaryDescription:
          "Inkblot Therapy is Canada's top provider of online video-based one-on-one or couples counselling. Care is provided by highly experienced professionals across Canada. Inkblot highly values long-term relationships with care providers. Your initial individual consultation is complimentary, following which, Canadian Bank Note Comany Limited, covers you and your eligible dependents for 10 counselling hours each. Subsequent sessions are reimbursable through your paramedical health coverage or paid privately.<br>",
        frPrimaryDescription:
          'Thérapie Inkblot est le premier fournisseur canadien de services de conseil en ligne par vidéo, en individuel ou en couple. Les soins sont fournis par des professionnels hautement expérimentés à travers le Canada. Inkblot accorde une grande importance aux relations à long terme avec les prestataires de soins. Votre première consultation individuelle est gratuite. Suite à la consultation initiale, Canadian Bank Note Company Limited couvre vous et vos personnes à charge admissibles, pour 10 heures de consultation chacun. Les séances ultérieures sont remboursables par votre couverture paramédicale ou payées à titre privé<br>',
        secondaryDescription:
          'Most suitable for those seeking online counselling and a longer-term relationship with their counsellor.',
        frSecondaryDescription:
          'Convient particulièrement aux personnes qui recherchent un conseil en ligne et une relation à long terme avec leur conseiller',
        buttonLabel: 'Launch Inkblot',
        frButtonLabel: 'Lancer Inkblot',
        buttonUrl: 'https://inkblottherapy.com/cbncoeap',
      },
      {
        logo: tranquilityLogo,
        path: 'tranquility',
        type: 'Internet Cognitive Behavioural Therapy (iCBT)',
        frType: 'Thérapie cognitivo-comportementale sur Internet (TCCI)',
        name: 'Tranquility by Inkblot',
        frName: 'Tranquility par Inkblot',
        primaryDescription:
          'Tranquility by Inkblot is an innovative program offering internet cognitive behavioural therapy (ICBT) to help you reduce mild to moderate symptoms of anxiety and depression right from the comfort of home. Learn positive coping strategies and reduce life-disrupting mental health symptoms through our interactive learning modules and tools.',
        frPrimaryDescription:
          'Tranquility par Inkblot est un programme innovant qui propose une thérapie cognitivo-comportementale sur Internet (TCCI) pour vous aider à réduire les symptômes légers à modérés de l’anxiété et de la dépression, dans le confort de votre domicile. Apprenez des stratégies d’adaptation positives et réduisez les symptômes de santé mentale qui perturbent la vie grâce à nos modules d’apprentissage interactifs, et nos outils.',
        buttonLabel: 'Register for Tranquility by Inkblot ',
        frButtonLabel: 'Inscrivez-vous à Tranquility par Inkblot',
        buttonUrl: 'https://cbnco.tranquility.app/onboarding',
      },
    ],
  },
  {
    marketingURL: 'cineplexeap',
    path: 'cineplexeap',
    french: true,
    logo: cineplexLogo,
    frLogo: cineplexFrLogo,
    title: 'Your Employee Assistance Program (EAP) Resources',
    frTitle: "Les ressources de votre programme d'aide aux employés (PAE)",
    subTitle: 'Learn more about your wellness benefits available to you.',
    frSubTitle:
      'Apprenez-en davantage sur les bénéfices en matière de bien-être qui vous sont offerts.',
    providers: [
      {
        logo: darkInkblotLogo,
        path: 'inkblot',
        ...CommonLogoStyle,
      },
      {
        logo: newTranquilityLogo,
        frLogo: tranquilityFrLogo,
        path: 'tranquility',
        ...CommonLogoStyle,
      },
    ],
    provider_sections: [
      {
        logo: darkInkblotLogo,
        logoBorderColor: '#16224c',
        path: 'inkblot',
        type: 'Virtual Therapy',
        frType: 'Thérapie Virtuelle',
        name: 'Inkblot Therapy',
        frName: 'Thérapie Inkblot',
        primaryDescription:
          'Inkblot Therapy is a Canadian provider of digital-first mental health and wellbeing services. Access is on-line with the ability for employees to select from a short-list of best-matched counsellors based on their unique needs and preferences. Appointments are booked directly on-line with their selected counsellor at their convenience.  Counselling sessions are delivered through Inkblot’s secure and encrypted video platform, by phone or in-person where feasible. Advisory services are also available including legal, financial, health, career and life transitions. All Full-time employees will have 5 sponsored hours of individual and 5 sponsored hours of  couples counselling included. All Part-time employees will have 3 sponsored hours of individual and 5 sponsored hours of  couples counselling included.<br>',
        frPrimaryDescription:
          "Thérapie Inkblot est un fournisseur canadien de services de santé mentale et de bien-être axés sur le numérique. L'accès est en ligne avec la possibilité de choisir parmi une courte liste de conseillers et conseillères qui correspondent le mieux à vos besoins et à vos préférences uniques. Les rendez-vous sont réservés directement en ligne avec votre conseiller ou conseillère, aussi rapidement que le jour même ou le lendemain.  Les rendez-vous sont fixés directement en ligne; la première consultation, jusqu’à 15 minutes, est gratuite afin de s’assurer de la qualité du jumelage pour une bonne alliance thérapeutique et, comme toutes les autres, peut être réservée à votre convenance, aussi rapidement que le jour même ou le lendemain.  Des services consultatifs sont également disponibles, incluant les conseils juridiques, financiers, liés à la santé, la carrière et transition de vie. Tous les employés à temps plein bénéficieront de 5 heures commanditées de consultation individuelle et de 5 heures commanditées de consultation de couple. Tous les employés à temps partiel bénéficieront de 3 heures commanditées de conseil individuel et de 5 heures commanditées de conseil en couple.<br>",
        secondaryDescription:
          'Most suitable for those seeking online counselling and a longer-term relationship with their counsellor.',
        frSecondaryDescription:
          'Mieux adapté à ceux qui désirent suivre une thérapie en ligne et développer une relation à long terme avec leur conseiller.e.',
        buttonLabel: 'Launch Inkblot (Full-time)',
        frButtonLabel: 'Lancer Inkblot (Temps plein)',
        buttonUrl: 'https://inkblottherapy.com/eapcineplex',
        secondButtonLabel: 'Launch Inkblot (Part-time)',
        secondFrButtonLabel: 'Lancer Inkblot (Temps partiel)',
        secondButtonUrl: 'https://inkblottherapy.com/cineplex',
      },
      {
        logo: newTranquilityLogo,
        frLogo: tranquilityFrLogo,
        path: 'tranquility',
        type: 'Internet Cognitive Behavioural Therapy (iCBT)',
        frType: 'Thérapie cognitivo-comportementale sur Internet (TCCI)',
        name: 'Tranquility by Inkblot',
        frName: 'Tranquility par Inkblot',
        primaryDescription:
          'Tranquility by Inkblot is an innovative program offering internet cognitive behavioural therapy (ICBT) to help you reduce mild to moderate symptoms of anxiety and depression right from the comfort of home. Learn positive coping strategies and reduce life-disrupting mental health symptoms through our interactive learning modules and tools. Tranquility is designed for adults (18+) experiencing stress, anxiety, low mood, and depression.',
        frPrimaryDescription:
          "Tranquility par Inkblot est un programme innovant qui propose une thérapie cognitivo-comportementale sur Internet (TCCI) pour vous aider à réduire les symptômes légers à modérés de l'anxiété et de la dépression, dans le confort de votre domicile. Apprenez des stratégies d'adaptation positives et réduisez les symptômes de santé mentale qui perturbent la vie grâce à nos modules d'apprentissage interactifs, et nos outils. Tranquility est conçu pour les adultes (18+) souffrant de stress, d'anxiété, de baisse d'humeur et de dépression.",
        buttonLabel: 'Register for Tranquility by Inkblot',
        frButtonLabel: 'Inscrivez-vous à Tranquility par Inkblot',
        buttonUrl: 'https://cineplex.tranquility.app/onboarding',
      },
    ],
  },
  {
    marketingURL: 'fppmsante',
    path: 'fppmsante',
    french: true,
    frenchOnly: true,
    frLogo: FppmLogo,
    frTitle: 'Vos ressources en santé mentale',
    frSubTitle:
      'Apprenez-en davantage sur les bénéfices en matière de bien-être qui vous sont offerts par la FPPM',
    providers: [
      {
        logo: darkInkblotLogo,
        path: 'inkblot',
        ...CommonLogoStyle,
      },
      {
        logo: mapleLogo,
        path: 'maple',
        ...CommonLogoStyle,
      },
      {
        logo: haleoLogo,
        path: 'haleo',
        ...CommonLogoStyle,
      },
    ],
    provider_sections: [
      {
        logo: darkInkblotLogo,
        logoBorderColor: '#16224c',
        path: 'inkblot',
        frType: 'Thérapie Virtuelle',
        frName: 'Thérapie Inkblot',
        frPrimaryDescription:
          "Notez bien que ce service ne peut d’aucune façon être considéré comme un substitut au PAPP pour le policier actif. Il s’agit bien d’un service complémentaire, le PAPP représentant la ressource pertinente en cas de risque suicidaire, de blessure grave, d’événement majeur ou d’hospitalisation d’un policier ou d’une policière en devoir. <br><br>Thérapie Inkblot est un fournisseur canadien de services de santé mentale et de bien-être axés sur le numérique.  L'accès est en ligne avec la possibilité de choisir parmi une courte liste de conseillers et conseillères qui correspondent le mieux à vos besoins et à vos préférences uniques. Les rendez-vous sont réservés directement en ligne avec votre conseiller ou conseillère, aussi rapidement que le jour même ou le lendemain.  Les rendez-vous sont fixés directement en ligne; la première consultation, jusqu’à 15 minutes, est gratuite afin de s’assurer de la qualité du jumelage pour une bonne alliance thérapeutique et, comme toutes les autres, peut être réservée à votre convenance, aussi rapidement que le jour même ou le lendemain.  ",
        frSecondaryDescription:
          'Mieux adapté à ceux qui désirent suivre une thérapie en ligne et développer une relation à long terme avec leur conseiller.e.',
        frButtonLabel: 'Lancer Inkblot',
        buttonUrl: 'https://therapieinkblot.com/fppm',
      },
      {
        logo: mapleLogo,
        logoBorderColor: '#16224c',
        path: 'maple',
        frType: 'Télémedecine',
        frName: 'Maple',
        frPrimaryDescription:
          'Oubliez les cliniques sans rendez-vous au Canada. Consultez un médecin en ligne, un spécialiste ou un infirmier praticien et obtenez un diagnostic, des conseils médicaux, des demandes d’analyses en laboratoire et plus encore à partir de votre téléphone, de votre tablette ou de votre ordinateur, sans référence. ',
        frSecondaryDescription:
          'Mieux adapté à ceux qui désirent suivre une thérapie en ligne et développer une relation à long terme avec leur conseiller.e.',
        frButtonLabel:
          'Créez votre compte Maple pour recevoir votre couverture de GSC.',
        buttonUrl: 'https://getmaple.ca/greenshield',
      },
      {
        logo: haleoLogo,
        logoBorderColor: '#fff',
        path: 'haleo',
        frType: 'HALEO Clinique',
        frName: 'HALEO',
        frPrimaryDescription:
          'HALEO est une clinique spécialisée en santé du sommeil. Nous offrons un dépistage pour plusieurs troubles du sommeil communs, ainsi que des solutions cliniques conçues par des experts du sommeil.',
        frSecondaryDescription:
          'Mieux adapté à ceux qui désirent suivre une thérapie en ligne et développer une relation à long terme avec leur conseiller.e.',
        frButtonLabel: 'Lancer HALEO',
        buttonUrl:
          'https://evaluation.haleoclinic.com/screener/sign-up/fppm/fr-ca',
        frButtonUrl:
          'https://evaluation.haleoclinic.com/screener/sign-up/fppm/fr-ca',
      },
      {
        logo: FppmLogo,
        logoBorderColor: '#fff',
        path: 'ppap',
        frType: 'PAPP (PROGRAMME D’AIDE AUX POLICIERS ET POLICIÈRES)',
        frName: 'PAPP (PROGRAMME D’AIDE AUX POLICIERS ET POLICIÈRES)',
        frPrimaryDescription:
          'Le PAPP s’agit bien d’un service complémentaire d’Inkblot et le PAPP représentent la ressource pertinente en cas de risque suicidaire, de blessure grave, d’événement majeur ou d’hospitalisation d’un policier ou d’une policière en devoir.',
        frSecondaryDescription:
          'Policier-Ressource: 514-289-BLEU (2358), MISE: 514-280-9067',
        frButtonLabel: '514-280-9271',
      },
      {
        logo: FppmLogo,
        logoBorderColor: '#fff',
        path: 'empi',
        frType: 'EMPI (Équipe multidisciplinaire post-incident)',
        frName: 'EMPI (Équipe multidisciplinaire post-incident)',
        frPrimaryDescription:
          'La section Emploi de la force (SEF), le Programme d&rsquo;aide au personnel policier (PAPP) et le Module d&rsquo;intervention en soutien aux employ&eacute;s (MISE) ont d&eacute;cid&eacute; de s&rsquo;associer dans la cr&eacute;ation de l&rsquo;&Eacute;quipe multidisciplinaire post-incident (EMPI). Cette collaboration vise &agrave; r&eacute;pondre aux diff&eacute;rents besoins identifi&eacute;s &agrave; la suite d&rsquo;un incident critique et d&rsquo;intervenir aupr&egrave;s des policiers touch&eacute;s. L&rsquo;expertise combin&eacute;e des unit&eacute;s impliqu&eacute;es dans l&rsquo;EMPI va permettre d&rsquo;offrir un soutien global &agrave; la poursuite et &agrave; la reprise des activit&eacute;s polici&egrave;res.',
        frSecondaryDescription:
          '<p>Incident critique<br />Un incident critique est un &eacute;v&eacute;nement o&ugrave; le policier est directement ou indirectement confront&eacute; &agrave; la mort<br />ou &agrave; des blessures graves ou qui a un impact sur sa survie physique, psychologique ou &eacute;motionnelle.</p> <p>Intervention post-incident<br />Il s&rsquo;agit d&rsquo;une intervention qui a pour objectif d&rsquo;assister le retour en fonction du policier &agrave; la suite d&rsquo;un<br />incident ayant un impact sur sa confiance ou ses capacit&eacute;s. La perception d&rsquo;un &eacute;v&eacute;nement peut &ecirc;tre<br />diff&eacute;rente d&rsquo;un policier &agrave; l&rsquo;autre. De plus, la d&eacute;marche personnalis&eacute;e demeure volontaire.</p> <p>Services offerts</p> <p>- SEF<br />- S&eacute;ance de tir<br />- Formation sur mesure (individuelle, en duo ou en &eacute;quipe)<br />- Sc&eacute;narios de base (simple ou &agrave; r&eacute;alit&eacute; complexe)<br />- R&eacute;troaction op&eacute;rationnelle</p> <p>PAPP<br />- D&eacute;briefing &eacute;motionnel<br />- Consultations confidentielles <br />- &Eacute;valuation des besoins et planification des protocoles d&rsquo;exposition<br />- Supervision de la prise en charge (au besoin)</p> <p>MISE<br />- R&eacute;int&eacute;gration &agrave; la patrouille<br />- D&eacute;sensibilisation ou exposition in vivo<br />- Plan de retour au travail<br />- Rencontres d&rsquo;&eacute;quipes et retours d&rsquo;exp&eacute;rience<br />- Vigie des appels</p> <p>Nous joindre<br />&Eacute;quipe multidisciplinaire post-incident (EMPI)<br />Courriel : post_incident@spvm.qc.ca<br />T&eacute;l&eacute;phone (bo&icirc;te vocale) : 514 280-9856</p>',
      },
    ],
  },
  {
    marketingURL: 'lululemonwellness',
    path: 'lululemonwellness',
    logo: LululemonLogo,
    title: 'lululemon Benefits',
    subTitle:
      'Learn more about the benefits that are available to you. Click below on the benefit you would like to access.',
    providers: [
      {
        logo: darkInkblotLogo,
        path: 'inkblot',
        ...CommonLogoStyle,
      },
      {
        logo: tranquilityLogo,
        path: 'tranquility',
        ...CommonLogoStyle,
      },
      {
        logo: LululemonLogoTwo,
        path: 'lululemonCare',
        ...CommonLogoStyle,
      },
      {
        logo: LululemonLogoTwo,
        path: 'employeeAccommodations',
        ...CommonLogoStyle,
      },
      {
        logo: LululemonLogoTwo,
        path: 'benefitsCanada',
        ...CommonLogoStyle,
      },
    ],
    provider_sections: [
      {
        logo: darkInkblotLogo,
        logoBorderColor: '#16224c',
        path: 'inkblot',
        type: 'EAP',
        name: 'Inkblot',
        primaryDescription:
          "Inkblot Therapy is Canada's top provider of online video-based one-on-one or couples counselling. Care is provided by highly experienced professionals across Canada. Inkblot highly values long-term relationships with care providers. Sessions may be reimbursable through your paramedical health coverage.",
        buttonLabel: 'launch Inkblot',
        buttonUrl: 'https://inkblottherapy.com/lululemon',
      },
      {
        logo: tranquilityLogo,
        path: 'tranquility',
        type: 'Coach-assisted ICBT',
        name: 'Tranqulity by Inkblot',
        primaryDescription:
          'Tranquility by Inkblot is an innovative program offering internet cognitive behavioural therapy (ICBT) to help you reduce mild to moderate symptoms of anxiety and depression right from the comfort of home. Learn positive coping strategies and reduce life-disrupting mental health symptoms through our interactive learning modules, tools and one-to-one coaching sessions. Work through the modules at your own pace and your own time.',
        buttonLabel: 'Register for Tranquility by Inkblot',
        buttonUrl: 'https://lululemon.tranquility.app/onboarding',
      },
      {
        logo: LululemonLogoTwo,
        logoClass: 'small-logo',
        path: 'lululemonCare',
        type: 'lululemon mental health training',
        name: 'lululemonCare',
        primaryDescription:
          'Our mental health training is a new initiative that builds on existing company programs that focus on wellbeing. Through this training, participants will be equipped with the tools to identify signs of emotional distress for those around them, in their day-to-day; enabling them to feel confident in connecting others to the appropriate resources, including our own mental health benefits. <br/><br/>This four-hour program is delivered in four modules designed to <b>increase awareness</b> of the most common mental health concerns, <b>reduce stigma</b> surrounding the discussion of mental health in the workplace, and <b>facilitate access to resources</b> for mental health.',
        buttonLabel: 'Sign up for lululemonCARE training.',
        buttonUrl:
          'https://lululemon.sharepoint.com/sites/Benefits/SitePages/Mental-Health-First-Aid.aspx',
      },
      {
        logo: LululemonLogoTwo,
        logoClass: 'small-logo',
        path: 'employeeAccommodations',
        type: ' ',
        name: 'Employee Accommodations',
        primaryDescription:
          'At lululemon, our goal is to foster a respectful, positive, and inclusive work environment where diversity and inclusion are not only celebrated but fully expressed as a defining aspect of our culture.<br/><br/>One of the ways we experience this is by actively removing barriers to equity and ensuring that every employee has equitable access to our hiring processes and workplace, through our workplace Accommodation Program.',
        buttonLabel: "Learn more about lululemon's Accommodations Process",
        buttonUrl:
          'https://lululemon.sharepoint.com/sites/EmployeeAccommodations',
      },
      {
        logo: LululemonLogoTwo,
        logoClass: 'small-logo',
        path: 'benefitsCanada',
        type: 'Flexible suite of benefit offerings',
        name: 'Benefits Canada',
        primaryDescription:
          "We strive to elevate our employee experience through a flexible suite of benefit offerings that support our people to live their best lives. <br/><br/><b>Extended Health Benefits:</b><br/>We care for our people by providing a comprehensive health benefits program for eligible employees and dependents. This includes medical, dental, vision, and other applicable programs in local markets. <br/><br/>To get started, go to <a href='https://myapplications.microsoft.com'>MyApps</a> and click Benefits Canada to enroll. This portal is also where you'll go to check coverage (My Elections), or report a life event to make any changes to your coverage.<br/><br/>Once enrolled into benefits coverage, Canada Life's GroupNet portal <a href='https://my.canadalife.com/sign-in'>Canada Life's GroupNet portal</a> is where you can create an account to make access/print digital ID cards, submit online claims, and register for direct deposit. <br/><br/><b>Parenthood program:</b><br/>lululemon understands the importance of parents taking time off work to be with a newborn or newly adopted child, and we want to support employees during this time by providing a parenthood top-up program. Full-time, benefits-eligible lululemon employees with 2+ years of service are eligible for the <a href='https://lululemon.sharepoint.com/sites/TimeOffAndLeaves/SitePages/Parenthood-Top-Up(1).aspx'>Parenthood top-up program</a>.<br/><br/><b>Sweaty Pursuits:</b><br/><a href='https://lululemon.sharepoint.com/sites/Benefits/SitePages/Sweaty-Pursuits(1).aspx'>The Sweaty Pursuits program</a> enables and fosters wellbeing. Its intention to support all of us in getting active, being present, and enabling us to reach our health goals while connecting more deeply with ourselves and our community.<br/><br/><b>Fund Your Future:</b><br/>To support our people on their path to financial wellness we offer a retirement savings program (RRSP) and employee share purchase plan (ESPP), with company matching. At lululemon, we believe that when our people's lives work, work works. Creating a life that works means feeling supported in building our financial future - and the <a href='https://lululemon.sharepoint.com/sites/Benefits/SitePages/Canada-Fund-Your-Future.aspx'>Fund Your Future program</a> is here to do just that!",
        buttonLabel: "Learn more about lululemon's benefit offerings.",
        buttonUrl:
          'https://lululemon.sharepoint.com/sites/Benefits/SitePages/Fund-your-Future.aspx',
      },
    ],
  },
  {
    marketingURL: 'mbctoolkit',
    path: 'mbctoolkit',
    french: true,
    logo: inConfidenceLogo,
    secondLogo: InkblotWordmarkLogo,
    frLogo: inConfidenceFrLogo,
    excludeYourProvider: true,
    noProvider: true,
    title:
      '<i>Toolkit for the <span class="medavie">inConfidence</span> Employee Family Assistance Program</i>',
    frTitle:
      'Trousse d’outils du Programme d’aide aux employés et leur famille',
    subTitle:
      '<i>inConfidence powered by Inkblot is <span class="medavie">your</span> confidential and comprehensive Employee & Family Assistance Program (EFAP). Accessible 24 hours a day, seven days a week, inConfidence provides members access to valuable resources for their physical, financial, and emotional wellbeing.</i>',
    frSubTitle:
      '<i>enÉquilibre propulsé par Inkblot est <span class="medavie">votre</span> programme d’aide aux employés et leur famille (PAEF). Accessible 24 heures sur 24, 7 jours sur 7, ce programme confidentiel et complet offre aux adhérents un accès à de précieuses ressources pour favoriser leur bien-être physique, financier et affectif.</i>',
    providers: [
      {
        logo: MedavieProvider1,
        path: 'awareness',
        ...CommonLogoStyle,
      },
      {
        logo: MedavieProvider2,
        path: 'orientation',
        ...CommonLogoStyle,
      },
      {
        logo: MedavieProvider3,
        path: 'medavie-faq',
        ...CommonLogoStyle,
      },
      {
        logo: MedavieProvider4,
        path: 'hr',
        ...CommonLogoStyle,
      },
      {
        logo: MedavieProvider5,
        path: 'wellness',
        ...CommonLogoStyle,
      },
    ],
    provider_sections: [
      {
        logo: MedavieProvider1,
        path: 'awareness',
        noBorder: true,
        customBackground: '#f5f5f5',
        customType: '#0094D7',
        type: 'Ongoing Awareness and Promotion',
        frType: 'Sensibilisation et Promotion Continues',
        name: 'Promotional Material and Communication Templates',
        frName: 'Matériel promotionnel',
        primaryDescription:
          'Familiarize your members <span class="medavie">and people leaders</span> with inConfidence and what it can offer.',
        frPrimaryDescription:
          'Aidez vos adhérents et vos gestionnaires à se familiariser avec enÉquilibre et les services offerts par ce programme grâce à la fiche de présentation',
        secondaryDescription:
          "<i>A strong launch and well-thought-out ongoing promotion strategy are important for building and maintaining employee awareness about your <span class='medavie'>inConfidence</span> program.</i>",
        frSecondaryDescription:
          "<i>Un lancement énergique et une stratégie de promotion continue avisée sont importants pour sensibiliser les employés à votre programme <span class='medavie'>enÉquilibre.</span></i> ",
        buttonLabel: 'Download',
        frButtonLabel: 'Télécharger',
        buttonUrl:
          'https://cdn.inkblottherapy.com/static/documents/mbc/MBCinConfidenceDec_2024.zip',
        frButtonUrl:
          'https://cdn.inkblottherapy.com/static/documents/mbc/CBMenEquilibreDec_2024.zip',
      },
      {
        logo: MedavieProvider2,
        path: 'orientation',
        noBorder: true,
        customBackground: '#fff',
        customType: '#0094D7',
        type: 'Orientation Session',
        frType: "Séance d'orientation",
        name: 'Free Orientation Webinars for Members and People Leaders',
        frName:
          "Webinaires d'orientation gratuits pour les adhérents et les gestionnaires",
        primaryDescription:
          'Scheduled education sessions for your members to learn more about the program.',
        frPrimaryDescription:
          "Séances d'information planifiées pour présenter le programme à vos adhérents.",
        buttonLabel: 'Members',
        frButtonLabel: 'Les Adhérents',
        secondButtonLabel: 'People Leaders',
        secondFrButtonLabel: 'Les Gestionnaires',
        buttonUrl:
          'https://inkblottherapy.zoom.us/webinar/register/WN_Y4SU7o5nSFiqR9IZcNgZUg#/registration',
        secondButtonUrl:
          'https://inkblottherapy.zoom.us/webinar/register/WN_wwLoIcKNRGmRWxJdJkJPcA#/registration',
        frButtonUrl:
          'https://inkblottherapy.zoom.us/webinar/register/WN_Y4SU7o5nSFiqR9IZcNgZUg#/registration',
        secondFrButtonUrl:
          'https://inkblottherapy.zoom.us/webinar/register/WN_wwLoIcKNRGmRWxJdJkJPcA#/registration',
      },
      {
        logo: MedavieProvider3,
        path: 'medavie-faq',
        noBorder: true,
        customBackground: '#f5f5f5',
        customType: '#0094D7',
        type: 'faq',
        frType: 'faq',
        name: 'Plan Member Frequently Asked Questions',
        frName: 'Foire aux questions pour les adhérents',
        primaryDescription:
          "<i>Questions and answer for employees' frequently asked questions about the program.</i>",
        frPrimaryDescription:
          '<i>La FAQ contient les réponses aux questions les plus fréquemment posées par les employés sur le programme.</i>',
        buttonLabel: 'Download',
        frButtonLabel: 'Télécharger',
        buttonUrl:
          'https://cdn.inkblottherapy.com/static/documents/mbc/MBC_inConfidence_Plan+Member+FAQs.pdf',
        frButtonUrl:
          "https://cdn.inkblottherapy.com/static/documents/mbc/CBM_enE%CC%81quilibre_FAQ+a%CC%80+l'intention+des+adhe%CC%81rents.pdf",
      },
      {
        logo: MedavieProvider4,
        path: 'hr',
        noBorder: true,
        customBackground: '#fff',
        customType: '#0094D7',
        type: 'Program Features and Resources for Leaders',
        frType:
          'Caractéristiques du programme et ressources pour les responsables',
        name: 'HR/Manager consultations',
        frName: 'Consultations RH/gestionnaires',
        primaryDescription:
          '<i>As part of your program, you receive complimentary HR and management consultation regarding employee mental health, specific complex situations, and building and sustaining your mental health strategy.</i>',
        frPrimaryDescription:
          '<i>Dans le cadre de votre programme, vous recevez des consultations gratuites en matière de RH et de gestion concernant la santé mentale des employés, les situations complexes particulières, ainsi que l’établissement et le maintien de votre stratégie de santé mentale.</i>',
        secondaryDescription:
          "<i>To arrange a virtual consultation, make the request by contacting <a href='mailto:consultation@inkblottherapy.com'>consultation@inkblottherapy.com</a>. For immediate consultations call: 1-855-933-0103</i>",
        frSecondaryDescription:
          "<i>Pour organiser une consultation virtuelle, faites-en la demande en écrivant à <a href='mailto:consultation@therapieinkblot.com'>consultation@therapieinkblot.com</a>. Pour obtenir une consultation immédiate, appelez le : 1 855 933-0103</i>",
      },
      {
        logo: MedavieProvider5,
        path: 'wellness',
        noBorder: true,
        customBackground: '#f5f5f5',
        customType: '#0094D7',
        type: 'Program Features and Resources for Leaders',
        frType:
          'Caractéristiques du programme et ressources pour les responsables',
        name: 'Wellness Hub',
        frName: 'Espace Mieux-Être',
        primaryDescription:
          '<i>The Wellness Hub is a resource centre that provides expert-driven health and well-being topics led by our diverse network of nurses, clinicians, practitioners and career and lifestyle coaches. We help bridge the gap between work and mental health needs by offering a wide selection of articles across the mind, body, relationship and work categories.</i>',
        frPrimaryDescription:
          '<i>L’Espace mieux-être est un centre de ressources qui propose des sujets sur la santé et le bien-être fondés sur l’expertise et dirigé par notre réseau diversifié de personnel infirmier, de cliniciens, de praticiens et d’accompagnateurs en gestion et transition de carrière et en style de vie. Nous aidons à combler le fossé entre le travail et les besoins en matière de santé mentale en proposant un vaste choix d’articles dans les catégories esprit, corps, relations et travail.</i>',
        buttonLabel: 'VISIT WEBSITE',
        frButtonLabel: 'VISITEZ LE SITE',
        buttonUrl: 'http://wellnesshub.inkblottherapy.com/',
        frButtonUrl: 'https://wellnesshub.inkblottherapy.com/fr',
      },
      {
        logo: MedavieProvider6,
        path: 'mentalMembers',
        noBorder: true,
        customBackground: '#fff',
        customType: '#0094D7',
        type: 'MENTAL HEALTH TRAINING',
        frType: 'FORMATION EN SANTÉ MENTALE',
        name: 'Online Mental Health Training for Employees',
        frName: 'Formation en ligne sur la santé mentale pour les employés',
        primaryDescription:
          "Your team’s mental health shapes their mindset, interactions, quality of work and productivity. Inkblot online training sessions raise awareness of how mental health can impact their lives, while educating and reducing the stigma often associated with getting help. Offering mental health training sends a strong signal that your organization is committed to supporting employee health and well-being.<br /><br />In addition to our mental health training sessions, we've made available a templated memo and poster for your convenience, which can be downloaded below. Employees are encouraged to take advantage of this resource by self-registering for the program. Upon completion, participants will receive a certificate.",
        frPrimaryDescription:
          "Sensibiliser les employés aux problèmes de santé mentale, y compris aux signes et aux symptômes, ainsi qu’au rôle de la résilience dans le maintien d’une bonne santé mentale, et les soutenir en réduisant la stigmatisation souvent associée à la demande d’aide. Offrir une formation en santé mentale aux employés démontre votre reconnaissance et votre engagement à l’égard de cet aspect essentiel de la santé et du bien-être général des employés. Les employés qui terminent les cinq modules reçoivent un certificat de réussite.<br /><br />En plus de nos sessions de formation sur la santé mentale, nous avons mis à votre disposition un modèle de mémo et d'affiche que vous pouvez télécharger ci-dessous. Nous encourageons les employés à profiter de cette ressource en s'inscrivant eux-mêmes au programme. Les participants recevront un certificat à l'issue du programme.",
        secondaryDescription:
          '<span class="medavie"><b>This training is included in the program with no additional cost associated.',
        frSecondaryDescription:
          '<span class="medavie"><b>Cette formation est incluse dans le programme sans frais additionnels.',
        buttonLabel: 'Download',
        frButtonLabel: 'Télécharger',
        buttonUrl:
          'https://cdn.inkblottherapy.com/static/documents/mbc/inConfidence_Employee_Mental_Health_Training_Memo_(EN)_copy.pdf',
        frButtonUrl:
          'https://cdn.inkblottherapy.com/static/documents/mbc/MBC_Inkblot_Online_MH_Training_Employee+Memo_FR.pdf',
      },
      {
        logo: MedavieProvider7,
        path: 'mentalLeaders',
        noBorder: true,
        customBackground: '#f5f5f5',
        customType: '#0094D7',
        type: 'MENTAL HEALTH TRAINING',
        frType: 'FORMATION EN SANTÉ MENTALE',
        name: 'Online Mental Health Training for Managers',
        frName:
          'Formation en ligne sur la santé mentale pour les gestionnaires',
        primaryDescription:
          'As part of our training program, managers can learn a framework and develop the skills necessary to support those with mental health challenges. Managers can feel confident in addressing these situations by understanding how to communicate and demonstrate care. Inkblot offers this training to managers, supervisors, team leads, HR, or anyone who might come into contact with an employee experiencing distress and can, under their role, make a difference.',
        frPrimaryDescription:
          'Dans le cadre de notre programme de formation, les gestionnaires peuvent apprendre un cadre et développer les compétences nécessaires pour soutenir les personnes qui souffrent de problèmes de santé mentale. En comprenant comment communiquer et faire preuve de compassion, les gestionnaires peuvent se sentir en confiance pour prendre en charge ces situations. Inkblot propose cette formation aux gestionnaires, aux superviseurs, aux chefs d’équipe, aux RH, ou à toute personne susceptible d’entrer en contact avec un employé en détresse et qui peut, par son rôle, faire une différence.',
        secondaryDescription:
          'Please contact <a href="mailto:inconfidence@inkblottherapy.com">inconfidence@inkblottherapy.com</a> to learn more about pricing.',
        frSecondaryDescription:
          'Veuillez contacter <a href="mailto:enEquilibre@therapieinkblot.com">enEquilibre@therapieinkblot.com</a> pour en savoir plus sur les tarifs.',
      },
      {
        logo: MedavieProvider8,
        path: 'webinarsAndTraining',
        noBorder: true,
        customBackground: '#fff',
        customType: '#0094D7',
        type: 'WEBINARS AND TRAININGS',
        frType: 'WEBINAIRES ET FORMATIONS',
        name: 'Webinars and Trainings Catalogue',
        frName: 'Catalogue des webinaires et formations',
        primaryDescription:
          '<i>As your well-being partner, we’re dedicated to helping you create a healthier and engaged workforce every day of the year. Plan ahead for your employees by taking advantage of our expert-led health and wellness webinars customized to meet the needs of your teams.</i>',
        frPrimaryDescription:
          '<i>En tant que partenaire de votre bien-être, nous nous engageons à vous aider à créer une main-d’œuvre en meilleure santé et engagée chaque jour de l’année. Planifiez du contenu pour vos employés en profitant de nos webinaires sur la santé et le bien-être animés par des experts et personnalisés pour répondre aux besoins de vos équipes.</i>',
        secondaryDescription:
          '<i>Please contact <a href="mailto:inconfidence@inkblottherapy.com">inconfidence@inkblottherapy.com</a> to learn more about pricing.</i>',
        frSecondaryDescription:
          '<i>Veuillez contacter <a href="mailto:enEquilibre@therapieinkblot.com">enEquilibre@therapieinkblot.com</a> pour en savoir plus sur les tarifs.</i>',
        buttonLabel: 'Download',
        frButtonLabel: 'Télécharger',
        buttonUrl:
          'https://cdn.inkblottherapy.com/static/documents/mbc/MBC_inConfidence_Webinar+%26+Training+Catalogue.pdf',
        frButtonUrl:
          'https://cdn.inkblottherapy.com/static/documents/mbc/CBM_enE%CC%81quilibre_Catalogue+des+webinaires+et+formations.pdf',
      },
      {
        logo: MedavieProvider9,
        path: 'criticalIncident',
        noBorder: true,
        customBackground: '#fff',
        customType: '#0094D7',
        type: 'SPECIALIZED CLINICAL SERVICES',
        frType: 'SERVICES CLINIQUES SPÉCIALISÉS',
        name: 'Critical Incident/Trauma Support',
        frName: 'Incident critique / Soutien aux traumatismes',
        primaryDescription:
          "<i>Your organization's ability to effectively navigate critical incidents is crucial for maintaining employee well-being and productivity. The inConfidence Critical Incident Response Program powered by Inkblot offers tailored interventions to address the aftermath of highly stressful events, such as workplace accidents or sudden losses, mitigating the risk of long-term psychological distress.<br /><br /><span class='medavie'>The program includes three hours per year (virtual or on site) with a professional specialized in critical incident management. Additional hours are available and will be billed separately.</span></i>",
        frPrimaryDescription:
          "<i>La capacité de votre organisation à gérer efficacement les incidents critiques est cruciale pour maintenir le bien-être et la productivité des employés. Le programme EnEquilibre par Inkblot  de réponse aux incidents critiques propose des interventions sur mesure pour faire face aux conséquences d'événements très stressants, tels que les accidents du travail ou les pertes soudaines, en atténuant le risque de détresse psychologique à long terme.<br /><br /><span class='medavie'>Le programme comprend trois heures par année (virtuelles ou sur site) avec un professionnel spécialisé dans la gestion des incidents critiques. Des heures supplémentaires sont disponibles et seront facturées séparément.</span></i>",
        secondaryDescription:
          'Additional information regarding the Critical Incident Response Program, as well as additional considerations following a traumatic incident and helpful coping strategies are available for download below. A recording of a our critical incident management services overview is also available to <a style="color:#0094D7;text-decoration: none;" href="https://inkblottherapy.zoom.us/rec/play/_92RQulQfp7t2JCTP_mTibXfHA-GCR6TVrvnr2-rYVBoykFIf890b8cXxDmyiOh7sRjvo1-HmbAO4mT7.SSWDBKzJJLkYceAD?canPlayFromShare=true&from=share_recording_detail&startTime=1716472834000&componentName=rec-play&originRequestUrl=https%3A%2F%2Finkblottherapy.zoom.us%2Frec%2Fshare%2FBL02U0yxhH7kd1ys052O0wKdUGWY0eeCuuiozDCfvoG_H_gHs6Ibc9PQnxPJ3i7Y.L0kFVxt43goDz4ma%3FstartTime%3D1716472834000">view here</a>.<br /><br />To request a trauma service, email: <a href="mailto:inconfidence@inkblottherapy.com">inconfidence@inkblottherapy.com</a> (please put URGENT in the subject line) or call 1-855-933-0103 (24/7/365) and follow the prompts.',
        frSecondaryDescription:
          "Des informations supplémentaires concernant le programme de réponse aux incidents critiques, ainsi que des considérations supplémentaires à la suite d'un incident traumatisant et des stratégies d'adaptation utiles peuvent être téléchargées ci-dessous. Un enregistrement d'une présentation de nos services de gestion des incidents critiques est également <a style='color:#0094D7;text-decoration: none;' href='https://inkblottherapy.zoom.us/rec/play/q189VLXMRhQH3pkR488zibP1MKYtp3OFx9YU9SjN48kjrtvNgan-_a2FwvMjL02Lmn6EjzfTZY95mZlb.jmRktxcax8Q5JQNH?canPlayFromShare=true&from=my_recording&startTime=1716487192000&componentName=rec-play&originRequestUrl=https%3A%2F%2Finkblottherapy.zoom.us%2Frec%2Fshare%2FM3OlFq_niiSL9EnXkSNGx1psdD_gu3y1YRCdjU7eyNRipArs6_wh6aZNMO4DTlW5.lhLlSGMt55tuXaFF%3FstartTime%3D1716487192000'>disponible ici</a>.<br /><br />Pour demander un service de traumatologie, envoyez un courriel à l'adresse suivante : <a href='mailto:inconfidence@inkblottherapy.com'>inconfidence@inkblottherapy.com</a> (veuillez indiquer URGENT dans l'objet) ou appelez le 1-855-933-0103 (24/7/365) et suivez les instructions.",
      },
    ],
  },
];

export default corps;
